export class HelloWorker implements IWorker {
    Name = "HelloWorker";
    Priority = 999;
    Do(): void {
        // console.log("Executing " + this.Name)
    }
}
